module.exports = __webpack_public_path__ + "img/ignis-gls-plus-agua-marina.131bfd13.png";